import { render, staticRenderFns } from "./AddReferralByHand.vue?vue&type=template&id=7c804e60&scoped=true&"
import script from "./AddReferralByHand.vue?vue&type=script&lang=js&"
export * from "./AddReferralByHand.vue?vue&type=script&lang=js&"
import style0 from "./AddReferralByHand.vue?vue&type=style&index=0&id=7c804e60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c804e60",
  null
  
)

export default component.exports